<template>
  <!-- 有文章：左图右文卡片 -->
  <router-link v-if="guide.to" :to="normalizeTo(guide.to)" class="related-guide-card">
    <div v-if="guide.image" class="related-guide-card__media">
      <img :src="guide.image" :alt="guide.imageAlt || guide.title" loading="lazy" width="200" height="140">
    </div>
    <div class="related-guide-card__body">
      <span class="related-guide-card__label">Related guide</span>
      <h4 class="related-guide-card__title">{{ guide.title }}</h4>
      <p v-if="guide.excerpt" class="related-guide-card__excerpt">{{ guide.excerpt }}</p>
      <span class="related-guide-card__cta">Read guide →</span>
    </div>
  </router-link>
  <!-- 暂无文章：按文档文案展示 -->
  <p v-else class="related-guide-text">
    <strong>Related guide:</strong>
    {{ guide.title }}
  </p>
</template>

<script>
import { withTrailingSlash } from '@/utils/route-path';

export default {
	name: 'RelatedGuideCard',
	props: {
		guide: {
			type: Object,
			required: true,
		},
	},
	methods: {
		normalizeTo(to) {
			return withTrailingSlash(to);
		},
	},
};
</script>
